import { render, staticRenderFns } from "./LabourerPayment.vue?vue&type=template&id=4f764f74&scoped=true&"
import script from "./LabourerPayment.vue?vue&type=script&lang=js&"
export * from "./LabourerPayment.vue?vue&type=script&lang=js&"
import style0 from "./LabourerPayment.vue?vue&type=style&index=0&id=4f764f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f764f74",
  null
  
)

export default component.exports